import React, { useEffect, useState } from "react";
import eclinimg from "../../../assets/images/eclinpro.png";
import eclinfailedimg from "../../../assets/images/eClinProFailed.svg";

const EclinProSyncBadge = ({
  isSynced = false,
  label = "eClinPro Synced",
  isSyncedStatus,
  eclinProSyncResult,
}) => {
  const [show, setShow] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  // if (!isSynced) return null;

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({
      top: rect.bottom + 6,
      left: rect.left + rect.width / 2,
    });
    setShow(true);
  };

  // console.log('isSyncedStatus eclinProSyncResult', eclinProSyncResult)
  //   console.log('isSyncedStatus eclinProSyncResult.error', eclinProSyncResult?.error)
  const parsedErrorResult = JSON.parse(eclinProSyncResult);
  console.log("parsedErrorResult => ", parsedErrorResult);
  return (
    <>
      {/* Icon */}
      {(isSynced === true || isSyncedStatus === "failed") && (
        <img
          src={isSyncedStatus === "failed" ? eclinfailedimg : eclinimg}
          alt="eClinPro"
          className="h-4 w-4 object-contain cursor-pointer inline-block ml-2"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={() => setShow(false)}
        />
      )}

      {/* Tooltip (fixed, outside table flow) */}
      {show && (
        <div
          className="
            fixed z-[9999]
            bg-white text-[#1A1A1B]
            border border-[#E4E4E4]
            text-xs px-2 py-1 rounded
            shadow-md whitespace-nowrap
            pointer-events-none
          "
          style={{
            top: position.top,
            left: position.left,
            transform: "translateX(-50%)",
          }}
        >
          {isSyncedStatus == "failed" ? parsedErrorResult.error : label}
        </div>
      )}
    </>
  );
};

export default EclinProSyncBadge;
